import countryService from 'iso-country-currency';
import { expressCountries } from '../../constants/express';

export const getCurrencyByCountry = (country) => {
    // TODO: optimize this code
    const currencyParams = countryService
        .getAllISOCodes()
        .filter((c) => expressCountries.some((v) => v.iso === c.iso))
        .find((t) => t.iso === country);

    return currencyParams?.currency?.toLocaleLowerCase();
};
